import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class SvgIconService {
  private icons = [
    { name: 'mesh-close-button-12x12-icon', url: '/assets/icons/v19-svg-icons/close-button-12x12-icon.svg' },
    { name: 'mesh-arrow-back-16x12-icon', url: '/assets/icons/v19-svg-icons/arrow-back-16x12-icon.svg' },
  ];

  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer
  ) {}

  registerIcons(): void {
    this.icons.forEach((icon) => this.iconRegistry.addSvgIcon(icon.name, this.sanitizer.bypassSecurityTrustResourceUrl(icon.url)));
  }
}
